// extracted by mini-css-extract-plugin
module.exports = {"Button":"CancelButton_Button__xkcTq"};